<div class="loader-container" [ngClass]="size" *ngIf="loading && !errorLabel">
  <svg class="spinner-img" viewBox="25 25 50 50">
    <circle class="spinner-path" cx="50" cy="50" r="20" />
  </svg>
  <div *ngIf="showText" class="spinner-text">{{ label }}</div>
</div>

<div class="loader-container" [ngClass]="size" *ngIf="errorLabel">
  <span class="mdi text-danger mdi-alert-circle"></span>
  <div *ngIf="showText" class="spinner-text">{{ errorLabel }}</div>
</div>
